import(/* webpackMode: "eager", webpackExports: ["default"] */ "/hisea-ssr/src/components/CareGuidePage/careGuidePage.tsx");
